import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs } from "@mui/material";
import React, { SetStateAction, useEffect, useState } from "react";
import CreateEmbedForm from "../EmbedDrawer/CreateForm";
import Embedings from "../EmbedDrawer/Embedings";
import PublicApi from "../EmbedDrawer/PublicApi";
import WorkflowPublicApi from "../EmbedDrawer/WorkflowPublicApi";
import CloseIcon from '@mui/icons-material/Close';
import { Agent } from "../../../Shared-ui/Types/Agent";
import { MultiAgent } from "../../../Shared-ui/Types/MultiAgent";
import { WorkflowListItem } from "../../../Services/WorkflowService";


interface MyComponentProps {
  openEmbed: boolean
  setOpenEmbed: React.Dispatch<SetStateAction<boolean>>
  agent?: Agent
  multiAgent?: MultiAgent
  workflow?: WorkflowListItem
}



const Embed: React.FC<MyComponentProps> = (props) => {

  const [tabId, setTabId] = useState(0);

  console.log("Embed component rendered with agent:", props.agent, "multiAgent:", props.multiAgent, "and workflow:", props.workflow);

  const handleClose = () => {
    props.setOpenEmbed(false)
  }

  return (<>
    <Dialog open={props.openEmbed} onClose={() => props.setOpenEmbed(false)} fullWidth maxWidth="md">

      <DialogTitle sx={{ m: 0, p: 2, position: 'relative' }}>
        Connect
        <IconButton
          aria-label="close"
          onClick={() => props.setOpenEmbed(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Tabs
        value={tabId}
        onChange={(event: React.SyntheticEvent, newValue: number) => setTabId(newValue)}
        variant="fullWidth"
      >
        <Tab label="Api Key" />
        <Tab label="Embed" />
        <Tab label="Public API" />
      </Tabs>
      <DialogContent sx={{ minHeight: 400 }}>
        <Box
          sx={{
            mt: 1,
            minHeight: 400,
            height: { xs: "auto", md: 430 },
            p: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
          }}
        >
          {tabId === 0 && (
            <CreateEmbedForm
              agentId={props.agent ? props.agent.id : undefined}
              multiAgentId={props.multiAgent ? props.multiAgent.id : undefined}
              workflowId={props.workflow ? props.workflow.id : undefined}
              setTabId={setTabId}
              handleClose={handleClose}
              tabId={tabId}
            />
          )}
          {tabId === 1 && (props.agent || props.multiAgent || props.workflow) && (
            <Embedings
              agent={props.agent}
              multiAgent={props.multiAgent}
              workflow={props.workflow}
              setTabId={setTabId}
              tabId={tabId}
            />
          )}
          {tabId === 2 && (props.agent || props.workflow) && (
            <>
              {props.agent && (
                <PublicApi
                  agent={props.agent}
                />
              )}
              {props.workflow && (
                <WorkflowPublicApi
                  workflow={props.workflow}
                />
              )}
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  </>)
}

export default Embed;
